module.exports = __webpack_public_path__ + "img/warehouse.1e933d47.svg";